// 世界尺寸
export const PANEL_SIZE = 10;           // 面板 10×10 单位
export const BALL_RADIUS = 0.3;         // 球半径
export const WALL_HEIGHT = 0.5;         // 墙高
export const WALL_THICKNESS = 0.2;      // 墙厚
export const HOLE_RADIUS = 0.45;        // 陷阱洞半径（略大于球半径，确保能掉进去）
export const GOAL_RADIUS = 0.5;         // 终点检测半径

// 倾斜控制
export const MAX_TILT = (22 * Math.PI) / 180;  // 最大倾斜角度 ±22°
export const TILT_SMOOTHING = 8;               // 按住拖动时的响应速度
export const TILT_RETURN_SPEED = 5;            // 松开后的回正速度

// 物理
export const GRAVITY = 14;                     // 基础重力加速度
export const BALL_MASS = 1;                    // 球质量
export const PHYSICS_FIXED_TIMESTEP = 1 / 60;  // 物理固定步长
export const PHYSICS_MAX_SUBSTEPS = 3;         // 每帧最大子步数

// 动画
export const FALL_ANIMATION_DURATION = 700;    // 掉洞动画时长（毫秒）
export const BALL_IDLE_THRESHOLD_MS = 5000;    // 球静止多久触发"卡住"提示

// 相机
export const CAMERA_DISTANCE = 16;      // 相机距原点距离
export const CAMERA_ANGLE_DEG = 30;     // 拖动模式：相机俯角（°）
export const CAMERA_ANGLE_GYRO_DEG = 75;// 陀螺仪模式：更接近俯视，方向更直观
export const CAMERA_FOV = 45;           // 相机 FOV
export const CAMERA_FOLLOW_WEIGHT = 0.6; // 相机水平跟随球的权重（0=固定，1=完全跟随）
export const CAMERA_FOLLOW_SMOOTH = 6;  // 跟随平滑响应（越大越紧跟）
export const CAMERA_ANGLE_SMOOTH = 3;   // 俯角切换平滑（越大切得越快）

// 渲染
export const MAX_PIXEL_RATIO = 2;       // 高 DPI 屏幕上限

// 关卡
export const LEVEL_IDS = [1, 2, 3];
export const LAST_LEVEL_ID = 3;
